module.exports = __webpack_public_path__ + "static/2-5c60f646dbf412232c0b56453e966722.jpg";